export const APP_FILE_CSIO_LIST = "/csio";
export const APP_FILE_CSIO_PROGRESS  = "/csio-progress/:code";
export const APP_FILE_MANAGE_CSIO_TAB  = "/manage-csio-tab";
export const APP_FILE_CSIO_MAPING  = "/mapping";
export const APP_FILE_CONTROL_LOG_LIST  = "/control-log";
export const APP_FILE_CONTROL_LOG  = "/control-log/view";